import React, {Fragment, useState} from 'react';

import cs from 'classnames';

import {Mentionable} from 'app/components/general/Mentionable';

import {CommentTextForm} from './CommentTextForm';
import {HideDeletedCommentsCheckbox} from './HideDeletedCommentsCheckbox';

import type {CommentContentType} from 'sweet-types';

type Props = {
  onSubmit: (commentData: string) => Promise<unknown>;
  className?: string;
  buttonClass?: string;
  inputClass?: string;
  contentType: CommentContentType;
  objectId: string | number;
  hideTooltip?: boolean;
  showDeletedCheckbox?: boolean;
};

export const CommentForm = ({
  inputClass = '',
  buttonClass = '',
  className = '',
  onSubmit,
  contentType,
  objectId,
  hideTooltip,
  showDeletedCheckbox = true,
  ...other
}: Props) => {
  const [comment, setComment] = useState<string>('');
  const [idle, setIdle] = useState<boolean>(true);

  function handleSubmit(
    event:
      | React.SyntheticEvent<HTMLFormElement>
      | React.KeyboardEvent<HTMLDivElement>,
    currentComment?: string
  ) {
    const newComment = currentComment != null ? currentComment : comment;
    event.preventDefault();
    setComment('');
    setIdle(false);
    onSubmit(newComment).then(
      () => {
        setIdle(true);
      },
      () => setIdle(true)
    );
  }

  return (
    <Mentionable
      contentType={contentType}
      objectId={objectId}
      onChange={(comment: string) => setComment(comment)}
      onSubmit={handleSubmit}
      value={comment}
    >
      {({Field, fieldProps, mentionsMenu}) => (
        <Fragment>
          {mentionsMenu}
          <form {...other} onSubmit={handleSubmit}>
            <div
              className={cs('d-flex', 'align-items-center', {
                'justify-content-between': showDeletedCheckbox,
                'justify-content-end': !showDeletedCheckbox,
              })}
            >
              <HideDeletedCommentsCheckbox show={showDeletedCheckbox} />
            </div>
            <CommentTextForm
              className={className}
              inputClass={inputClass}
              buttonClass={buttonClass}
              submitButtonDisabled={!comment}
              isIdle={idle}
              MentionableField={Field}
              mentionableFieldProps={fieldProps}
              hideTooltip={hideTooltip ?? false}
            />
          </form>
        </Fragment>
      )}
    </Mentionable>
  );
};
